module.exports = __webpack_public_path__ + "img/illustration-forgot-password-light.069adc1b.png";